<span class="wordmark" aria-label="bitcoin plus plus">
  <span aria-hidden="true">bitcoin</span><span class="pluses" aria-hidden="true"><span>+</span><span>+</span></span>
</span>

<style>
  /*
   * Bitcoin++ wordmark contract:
   * - Ubuntu Bold Italic is reserved for this component.
   * - "bitcoin" keeps the typeface's natural tracking.
   * - only the second + overlaps the first +.
   */
  .wordmark {
    display: inline-flex;
    align-items: baseline;
    color: inherit;
    font-family: var(--brand);
    font-size: var(--wordmark-size, 28px);
    font-style: italic;
    font-weight: 700;
    letter-spacing: normal;
    line-height: .82;
    text-transform: none;
    white-space: nowrap;
  }
  .pluses { display: inline-flex; align-items: baseline; color: var(--wordmark-plus-color, inherit); letter-spacing: 0; }
  .pluses span + span { margin-left: -.16em; }
</style>
